var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"dialog",style:(( _obj = {}, _obj[_vm.direction] = '10%', _obj ))},[_vm._v("\n        "+_vm._s(_vm.text)+"\n        "),_c('span',{style:(( _obj$1 = {}, _obj$1[_vm.direction] = '80%', _obj$1 ))})])])}
var staticRenderFns = []

export { render, staticRenderFns }